import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface DeleteTransactionCodeParams {
  id: string;
}

export const deleteTransactionCode = async (
  params: DeleteTransactionCodeParams,
) => {
  const response = await baseAPI.delete<unknown>(
    `/transaction-code/${params.id}`,
  );
  return response.data;
};

export const useDeleteTransactionCode = () => {
  return useMutation({
    mutationFn: (params: DeleteTransactionCodeParams) =>
      deleteTransactionCode(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.TRANSACTION_CODE],
      });
    },
  });
};
